let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("I6PdM"), load("jgEe0"), load("6GKLk")]).then(() => parcelRequire('dcCDc'));